module.exports = __webpack_public_path__ + "static/shopify-logo-87b4ee570594af745ac856d3139b5757.svg";